import React from 'react';
import { Paper, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

interface TimeTableHoverComponentProps {
  label: string;
}

export default function TimeTableHoverComponent({
  label,
}: TimeTableHoverComponentProps) {
  return (
    <Paper
      elevation={8}
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        border: '1px dashed',
        borderColor: 'rating.empty',
        borderRadius: '0.8rem',
        width: '80%',
        height: '50%',
        opacity: 0,
        transition: 'opacity 0.3s',
        backgroundColor: 'main.white',
      }}
    >
      <Stack
        height="100%"
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={1}
      >
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ userSelect: 'none' }}
        >
          {label}
        </Typography>
        <AddIcon sx={{ fontSize: '1.6rem', color: 'icon.dark' }} />
      </Stack>
    </Paper>
  );
}
